package medicine.containers

import com.jingfangpai.api.clients.MedicineApiClient
import react.*
import react.dom.div
import setTitle
import medicine.components.MedicineList

external interface MedicineListPageProps : RProps {

}

data class MedicineListPageContextData(var getMedicineList: (okCallback: (result: com.jingfangpai.common.data.response.ApiResponse<List<com.jingfangpai.common.orm.mapping.Medicine>>) -> Unit, errorCallback: (Throwable) -> Unit) -> Unit)

val MedicineListPageContext = createContext(MedicineListPageContextData({ okCallback, errorCallback -> }))

val MedicineListPageProvider = functionalComponent<MedicineListPageProps> { props ->

    setTitle("中药")

    useEffectOnce {
        console.log("medicine list page")
    }

    MedicineListPageContext.Provider(MedicineListPageContextData(MedicineApiClient::getList)) {
        div("MedicineListPage-page") {
            child(MedicineList)
        }
    }
}
